module.exports = "/assets/dist/images/carsaver_at_walmart_logo.svg?0ecca73725387664531d6e071c8f1b9a";